import { z } from 'zod'
import { parse } from 'date-fns'

const MAX_DIFFERENCE_BETWEEN_DATES = 150

export const birthDateSchema = z
  .string()
  .transform((value) => parse(value, 'dd/MM/yyyy', new Date()))
  .refine((value) => !isNaN(value.getTime()), {
    message: 'Data de nascimento inválida'
  })
  .refine((value) => value <= new Date(), {
    message: 'Data deve ser menor ou igual à hoje'
  })
  .refine(
    (value) => {
      const age = new Date().getFullYear() - value.getFullYear()
      return age >= 0 && age <= MAX_DIFFERENCE_BETWEEN_DATES
    },
    { message: 'Data de nascimento inválida' }
  )

export const genderSchema = z
  .enum(['F', 'M'])
  .describe('Sexo deve ser informado')
